
import React, { useState, useEffect, useContext } from "react";
import { useParams, Link } from "react-router-dom";
import {
  VerticalTimeline,
  VerticalTimelineElement,
} from "react-vertical-timeline-component";
import "react-vertical-timeline-component/style.min.css";
import axios from "axios";
import { FaEnvelope, FaPlus, FaFileAlt } from "react-icons/fa";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import {
  Card,
  CardContent,
  Typography,
  Grid,
  Button,
  Box,
  IconButton,
  Modal,
  Snackbar,FormControlLabel,Checkbox,
  Tooltip,
  Alert,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
} from "@mui/material";
import { UserContext } from "../UserContext";
import "leaflet/dist/leaflet.css";
import StartIcon from "@mui/icons-material/PlayArrow";
import StopIcon from "@mui/icons-material/Pause";
import { FaEdit, FaPlay, FaStop } from "react-icons/fa";
import CryptoJS from "crypto-js";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import LabeledTextField from "./LabeledTextField";
import "./EnquiryDashboard.css";
import WorkHistoryIcon from "@mui/icons-material/WorkHistory";
import CloseIcon from '@mui/icons-material/Close';
const EnquiryDashboard = () => {
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const [feedbackModalOpen, setFeedbackModalOpen] = useState(false);
  const [feedbackModalMessage, setFeedbackModalMessage] = useState("");
  const [encryptedId, setEncryptedId] = useState(null);
  const { enquiryId, companyId , exportCompanyId} = useParams();
  const [timelineData, setTimelineData] = useState([]);
  const [message, setMessage] = useState("");
  const [file, setFile] = useState(null);
  const { user_id, role, addresses, setAddresses } = useContext(UserContext);
  const [companyDetails, setCompanyDetails] = useState({});
  const [date, setDate] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);
  const [modalMessage, setModalMessage] = useState("");
  const [eventSource, setEventSource] = useState(null);
  const [location, setLocation] = useState({ latitude: null, longitude: null });
  const [isTracking, setIsTracking] = useState(false);
  const [totalDurationSeconds, setTotalDurationSeconds] = useState(0);
  const [sessionId, setSessionId] = useState("");
  const [elapsedSeconds, setElapsedSeconds] = useState(0);
  const [hasFetchedDuration, setHasFetchedDuration] = useState(false);
  const [whatsappMessage, setWhatsappMessage] = useState("");
  const [whatsappFile, setWhatsappFile] = useState(null);
  const [address, setAddress] = useState("");
  const [showingStartTime, setShowingStartTime] = useState(true);
  const [startTime, setStartTime] = useState(
    parseInt(localStorage.getItem("startTime"), 10) || null
  );
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [open, setOpen] = useState(false);
  const [productModalOpen, setProductModalOpen] = useState(false);
const [mailModalOpen, setMailModalOpen] = useState(false);
const [products, setProducts] = useState([]);
const [selectedProducts, setSelectedProducts] = useState([]);
const [emailId, setEmailId] = useState('');
const [cc, setCc] = useState('');
const [emailBody, setEmailBody] = useState('');

  const [currentDate, setCurrentDate] = useState(getFormattedDate());

  function getFormattedDate() {
    const now = new Date();
    const day = now.toLocaleString("en-US", { weekday: "short" });
    const month = now.toLocaleString("en-US", { month: "short" });
    const date = now.toLocaleString("en-US", { day: "2-digit" });
    const year = now.getFullYear();
    const time = now.toLocaleString("en-US", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
    return `${day}, ${month} ${date}, ${year} ${time}`;
  }

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentDate(getFormattedDate());
    }, 1000);
    return () => clearInterval(timer);
  }, []);

  const handleClickOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const handleUpdate = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.put(
        `/api/client-enquiry/${enquiryId}/update/?user_id=${user_id}`,
        { enquiry_status: "Completed" }
      );
      setSnackbarMessage("Enquiry Closed Successfully");
      setSnackbarSeverity("success");
      setSnackbarOpen(true);
    } catch (err) {
      setSnackbarMessage(`Error: ${err.message}`);
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
    }
  };

  const item = timelineData.find((item) => item.current_location);
  useEffect(() => {
    if (item) {
      const coordinates = item.current_location;
      const [latitude, longitude] = coordinates.split(",").map(Number);
      fetch(
        `https://nominatim.openstreetmap.org/reverse?format=json&lat=${latitude}&lon=${longitude}`
      )
        .then((response) => response.json())
        .then((responseData) => setAddress(responseData.display_name))
        .catch((error) => console.error(error));
    }
  }, [item]);

  const handleCloseSnackbar = (event, reason) => {
    if (reason === "clickaway") return;
    setSnackbarOpen(false);
  };
const handleCloseModal = () => {
  setProductModalOpen(false);
};
  const fetchTimelineData = async () => {
    try {
      const response = await axios.get(
        `/api/enquiry-data/${enquiryId}/${companyId}/`
      );
      setTimelineData(response.data.timeline);
      setCompanyDetails(response.data.company);
    } catch (error) {
      console.error("Error fetching enquiry data", error);
    }
  };

  useEffect(() => {
    fetchTimelineData();
  }, [enquiryId, companyId]);

  const getAddressFromCoordinates = async (latitude, longitude) => {
    try {
      const response = await fetch(
        `https://nominatim.openstreetmap.org/reverse?lat=${latitude}&lon=${longitude}&format=json`
      );
      if (!response.ok) throw new Error("Failed to fetch address");
      const data = await response.json();
      return data.display_name;
    } catch (error) {
      console.error("Error fetching address:", error);
      return "Address not found";
    }
  };

  const renderDisplayValue = (val) => {
  if (val && typeof val === 'object') {
    // If it's a product object, show the name, otherwise stringify it
    return val.product_name || JSON.stringify(val);
  }
  return val;
};

  useEffect(() => {
    const fetchAddresses = async () => {
      const addressMap = {};
      for (const item of timelineData) {
        if (item.latitude && item.longitude) {
          const address = await getAddressFromCoordinates(
            item.latitude,
            item.longitude
          );
          addressMap[item.id] = address;
        }
      }
      setAddresses(addressMap);
    };
    fetchAddresses();
  }, [timelineData]);

  const handleDownload = (fileId) => {
    const link = document.createElement("a");
    link.href = `/api/download-file/${fileId}/?user_id=${user_id}`;
    link.download = true;
    link.click();
  };

  const handleFileChange = (event) => {
    setFile(event.target.files[0]);
  };

  const handleFileUpload = async () => {
    if (!file) {
      alert("Please select a file to upload");
      return;
    }
    navigator.geolocation.getCurrentPosition(
      async (position) => {
        const { latitude, longitude } = position.coords;
        const formData = new FormData();
        formData.append("file", file);
        formData.append("uploaded_by_id", user_id);
        formData.append("company_id", companyId);
        formData.append("enquiry", enquiryId);
        formData.append("location", JSON.stringify({ latitude, longitude }));
        try {
          await axios.post("/api/enquiry-file-upload/", formData, {
            headers: { "Content-Type": "multipart/form-data" },
          });
          openModal("File uploaded successfully");
          setFile(null);
          fetchTimelineData();
        } catch (error) {
          console.error("Error uploading file", error);
        }
      },
      (error) => {
        console.error("Error getting location", error);
        setSnackbarMessage(
          "Unable to retrieve your location. Please ensure location services are enabled."
        );
        setSnackbarOpen(true);
      }
    );
  };

  const handleSendMessage = async () => {
    if (!message) {
      alert("Please enter a message");
      return;
    }
    navigator.geolocation.getCurrentPosition(
      async (position) => {
        const { latitude, longitude } = position.coords;
        const requestData = {
          message,
          sent_by: user_id,
          company: companyId,
          enquiry: enquiryId,
          location: { latitude, longitude },
        };
        try {
          await axios.post("/api/send-enquiry-message/", requestData);
          openModal("Message sent successfully");
          setMessage("");
          setDate(null);
          fetchTimelineData();
        } catch (error) {
          console.error("Error sending message", error);
        }
      },
      (error) => {
        console.error("Error getting location", error);
        alert(
          "Unable to retrieve your location. Please ensure location services are enabled."
        );
      }
    );
  };

  const fetchCurrentLocation = async () => {
    try {
      const response = await fetch(`/api/get_location/${enquiryId}/`);
      const data = await response.json();
      if (data.latitude !== null && data.longitude !== null) {
        return {
          latitude: data.latitude,
          longitude: data.longitude,
          isTracking: data.is_tracking,
        };
      }
    } catch (error) {
      console.error("Error fetching employee location:", error);
    }
    return { latitude: null, longitude: null, isTracking: false };
  };

  const showMap = async () => {
    const currentLocation = await fetchCurrentLocation();
    const { latitude, longitude, isTracking } = currentLocation;
    if (isTracking) {
      if (latitude !== null && longitude !== null) {
        window.open(
          `https://www.openstreetmap.org/?mlat=${latitude}&mlon=${longitude}#map=18/${latitude}/${longitude}`,
          "_blank"
        );
      } else {
        console.warn("Invalid latitude or longitude for map display");
      }
    } else {
      alert("Tracking is not active.");
    }
  };


  const storeEmployeeLocation = (latitude, longitude, isTracking, sessionId) => {
    fetch(`/api/store_location/${enquiryId}/${companyId}/`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        latitude,
        longitude,
        is_tracking: isTracking,
        session_id: sessionId,
        uploaded_by_id: user_id,
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        console.log("Location stored successfully:", data);
      })
      .catch((error) => {
        console.error("Error storing location:", error);
      });
  };

  // const handleToggleTrack = () => {
  //   const newTrackingState = !isTracking;
  //   setIsTracking(newTrackingState);
  //   if (newTrackingState) {
  //     const newSessionId = Math.random().toString(36).substr(2, 9);
  //     setSessionId(newSessionId);
  //     if (navigator.geolocation) {
  //       navigator.geolocation.getCurrentPosition(
  //         (position) => {
  //           const { latitude, longitude } = position.coords;
  //           setLocation({ latitude, longitude });
  //           storeEmployeeLocation(latitude, longitude, true, newSessionId);
  //           window.location.reload();
  //         },
  //         (error) => {
  //           console.error("Error retrieving location:", error);
  //         }
  //       );
  //     } else {
  //       alert("Geolocation is not supported by this browser.");
  //     }
  //   } else {
  //     const { latitude, longitude } = location;
  //     storeEmployeeLocation(latitude, longitude, false, sessionId);
  //     window.location.reload();
  //   }
  // };
const handleToggleTrack = () => {
  const newTrackingState = !isTracking;
  setIsTracking(newTrackingState);
  
  if (!newTrackingState) {
    // Stopping tracking
    const { latitude, longitude } = location;
    storeEmployeeLocation(latitude, longitude, false, sessionId);
    
    // Cleanup resources
    clearInterval(intervalId);
    if (eventSource) {
      eventSource.close();
      setEventSource(null);
    }
    
    localStorage.removeItem("startTime");
    setStartTime(null);
    fetchTimelineData();
    
    // Reset tracking-related state
    setTotalDurationSeconds(0);
    setElapsedSeconds(0);
    setHasFetchedDuration(false);
  } else {
    // Starting tracking
    const newSessionId = Math.random().toString(36).substr(2, 9);
    setSessionId(newSessionId);
    const startTimeValue = Date.now();
    setStartTime(startTimeValue);
    localStorage.setItem("startTime", startTimeValue);
    
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const { latitude, longitude } = position.coords;
          setLocation({ latitude, longitude });
          storeEmployeeLocation(latitude, longitude, true, newSessionId);
        },
        (error) => {
          console.error("Error retrieving location:", error);
          setIsTracking(false); // Revert state change on error
        }
      );
    } else {
      alert("Geolocation is not supported by this browser.");
      setIsTracking(false); // Revert state change on error
    }
  }
};
let intervalId = null;

  const openConfirmationModal = () => setShowConfirmation(true);
  const closeConfirmationModal = () => setShowConfirmation(false);

const ConfirmationModal = ({ open, message, onConfirm, onCancel }) => {
  if (!open) return null;

  return (
    <>
      {/* Backdrop */}
      <div 
        className="confirmation-backdrop"
        onClick={onCancel}
      />
      
      {/* Modal Content */}
      <div className="confirmation-modal">
        <h2 className="confirmation-title">{message}</h2>
        <div className="confirmation-buttons">
          <button 
            className="confirmation-button confirm"
            onClick={onConfirm}
          >
            OK
          </button>
          <button 
            className="confirmation-button cancel"
            onClick={onCancel}
          >
            CANCEL
          </button>
        </div>
      </div>
    </>
  );
};

  useEffect(() => {
    if (isTracking) {
      const eventSource = new EventSource(`/api/live_track/${enquiryId}/`);
      setEventSource(eventSource);
      eventSource.onmessage = (event) => {
        const locationData = JSON.parse(event.data);
        if (locationData.latitude !== null && locationData.longitude !== null) {
          setLocation(locationData);
        }
      };
      eventSource.onerror = (error) => {
        console.error("Error connecting to live track:", error);
        setTimeout(() => {
          eventSource.close();
          setEventSource(new EventSource(`/api/live_track/${enquiryId}/`));
        }, 5000);
      };
      eventSource.onopen = () => {
        console.log("Connected to live track");
      };
      return () => {
        eventSource.close();
      };
    }
  }, [isTracking, enquiryId]);

  useEffect(() => {
    let intervalId;
    if (isTracking) {
      const fetchLocation = () => {
        fetch(`/api/get_location/${enquiryId}/`)
          .then((response) => response.json())
          .then((data) => {
            if (data.latitude !== null && data.longitude !== null) {
              setLocation({
                latitude: data.latitude,
                longitude: data.longitude,
              });
            }
          })
          .catch((error) => {
            console.error("Error fetching employee location:", error);
          });
      };
      fetchLocation();
      intervalId = setInterval(fetchLocation, 5000);
      return () => clearInterval(intervalId);
    }
  }, [isTracking, enquiryId]);

  const openModal = (message) => {
    setModalMessage(message);
    setModalOpen(true);
  };

  const fetchTotalDuration = async () => {
    try {
      const response = await fetch(`/api/get_total_duration/${enquiryId}/`);
      if (!response.ok) throw new Error("Network response was not ok");
      const data = await response.json();
      setStartTime(new Date(data.start_time));
      setIsTracking(data.is_tracking);
      if (!data.is_tracking) {
        setTotalDurationSeconds(data.total_duration_seconds || 0);
      }
    } catch (error) {
      console.error("Error fetching total duration:", error);
    }
  };

  useEffect(() => {
    fetchTotalDuration();
  }, [enquiryId]);

  useEffect(() => {
    let timer;
    if (isTracking) {
      setHasFetchedDuration(false);
      if (!startTime) {
        const newStartTime = Date.now();
        setStartTime(newStartTime);
        localStorage.setItem("startTime", newStartTime);
      }
      setShowingStartTime(true);
      timer = setInterval(() => {
        const currentElapsed = Math.floor((Date.now() - startTime) / 1000);
        setElapsedSeconds(currentElapsed);
      }, 1000);
    } else if (!hasFetchedDuration) {
      fetchTotalDuration();
      setHasFetchedDuration(true);
      setShowingStartTime(false);
    }
    return () => clearInterval(timer);
  }, [isTracking, startTime, hasFetchedDuration]);

  useEffect(() => {
    localStorage.setItem("isTracking", JSON.stringify(isTracking));
    if (!isTracking) {
      localStorage.removeItem("startTime");
      setStartTime(null);
    }
  }, [isTracking]);

  const formatTime = (seconds) => {
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const secs = seconds % 60;
    return { hours, minutes, secs };
  };

  const { hours, minutes, secs } = formatTime(
    showingStartTime ? elapsedSeconds : totalDurationSeconds
  );

  const handleSendWhatsappMessage = async () => {
    const whatsappNumber = companyDetails.mobile_number;
    try {
      const formData = new FormData();
      formData.append("message", whatsappMessage);
      formData.append("to", `+918148614356`);
      if (whatsappFile) {
        formData.append("file", whatsappFile);
      }
      await axios.post("/api/send-whatsapp/", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      setSnackbarMessage("WhatsApp message sent successfully");
      setSnackbarSeverity("success");
      setSnackbarOpen(true);
      setWhatsappMessage("");
      setWhatsappFile(null);
    } catch (error) {
      console.error("Error sending WhatsApp message", error);
      setSnackbarMessage("Failed to send WhatsApp message. Please try again.");
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
    }
  };
  useEffect(() => {
  fetch('/api/products/')
    .then(response => response.json())
    .then(data => setProducts(data));
}, []);

const handleProductSelect = (event, productId) => {
  if (event.target.checked) {
    setSelectedProducts([...selectedProducts, productId]);
  } else {
    setSelectedProducts(selectedProducts.filter(id => id !== productId));
  }
};

const handleSendProductMail = () => {
  setProductModalOpen(false);
  setMailModalOpen(true);
};

// const handleSubmitMail = () => {
//   // Call the API to send mail with selected products and email id
//   fetch('/api/send-mail/', {
//     method: 'POST',
//     headers: {
//       'Content-Type': 'application/json',
//     },
//     body: JSON.stringify({
//       email_id: emailId,
//       cc: cc,
//       product_ids: selectedProducts,
//     }),
//   })
//     .then(response => response.json())
//     .then(data => {
//       console.log(data);
//       setSelectedProducts([]); // Empty the selected products
//       setEmailId(''); // Empty the email id
//       setCc(''); // Empty the CC
//     });
//   setMailModalOpen(false);
// };
const handleSubmitMail = () => {
  // Call the API to send mail with selected products and email id
  fetch('/api/send-mail/', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      email_id: emailId,
      cc: cc,
      product_ids: selectedProducts,
      company_id: exportCompanyId,
      email_body: emailBody,
    }),
  })
    .then(response => response.json())
    .then(data => {
      console.log(data);
      setSelectedProducts([]); // Empty the selected products
      setEmailId(''); // Empty the email id
      setCc(''); // Empty the CC
      setEmailBody(''); // Empty the email body
      alert('Mail sent successfully!'); // Show success alert
    })
    .catch(error => {
      console.error(error);
      alert('Error sending mail. Please try again.'); // Show error alert
    })
    .finally(() => {
      setMailModalOpen(false);
    });
};
  const handleWhatsappFileChange = (event) => {
    setWhatsappFile(event.target.files[0]);
  };

  useEffect(() => {
    fetchTimelineData();
  }, [enquiryId, companyId]);

  useEffect(() => {
    const fetchReminder = async () => {
      try {
        const response = await axios.post("/api/reminder/");
        console.log("Reminder data:", response.data);
      } catch (error) {
        console.error("Error fetching reminder:", error);
      }
    };
    fetchReminder();
    const intervalId = setInterval(fetchReminder, 3600000);
    return () => clearInterval(intervalId);
  }, []);

  useEffect(() => {
    const encryptId = () => {
      try {
        const secretKey = "your";
        const ciphertext = CryptoJS.AES.encrypt(
          enquiryId.toString(),
          secretKey
        ).toString();
        setEncryptedId(ciphertext);
      } catch (error) {
        console.error("Error encrypting ID:", error);
      }
    };
    encryptId();
  }, [enquiryId]);

  const handleClick = () => {
    if (encryptedId) {
      const feedbackUrl = `/api/ClientFeedbackForm?id=${encryptedId}`;
      setFeedbackModalMessage(feedbackUrl);
      setFeedbackModalOpen(true);
    }
  };

  const handleCopy = () => {
    navigator.clipboard.writeText(feedbackModalMessage);
    setSnackbarOpen(true);
  };

  const FeedbackcloseModal = () => {
    setFeedbackModalOpen(false);
  };

  const closeModal = () => {
    setModalOpen(false);
  };

  const formatMeetingDateTime = (dateString) => {
    const options = {
      year: "numeric",
      month: "long",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    };
    return new Date(dateString).toLocaleString(undefined, options);
  };

  return (
    <div className="EnquiryDashboard">
      <div className="EnquiryHeader">
        <Box className="EnquiryHeaderIconBox">
          <WorkHistoryIcon className="EnquiryWorkHistoryIcon" />
          <span className="EnquiryTitle">History</span>
        </Box>
        <span className="EnquiryCurrentDate">{currentDate}</span>
      </div>

      <div className="EnquiryTopSection">
        <div className="EnquiryDuration">
          <Typography className="EnquiryDurationText">
{role === "Employee" ? (
  isTracking
    ? ` ${String(hours).padStart(2, "0")}:${String(minutes).padStart(
        2,
        "0"
      )}:${String(secs).padStart(2, "0")}`
    : `Total Duration: ${String(hours).padStart(2, "0")}:${String(
        minutes
      ).padStart(2, "0")}:${String(secs).padStart(2, "0")}`
) : null}
          </Typography>
        </div>
        <div className="EnquiryButtons">
          <Link to="/CompanyList" className="EnquiryLink">
            <Button
              variant="outlined"
              color="primary"
              className="EnquiryBackButton"
            >
              Back
            </Button>
          </Link>
          {(role === "Admin" || role === "Super Admin") && (
            <Button
              className="EnquiryCloseButton"
              onClick={handleClickOpen}
            >
              Close Enquiry
            </Button>
          )}
        </div>
      </div>

      <div className="EnquiryTwoColumnContainer">
        <div className="EnquiryColumn">
          <Card className="EnquiryCard">
            <CardContent>
              <Box className="EnquiryCardHeader">
                <Typography variant="h5" className="EnquiryCardTitle">
                  Company Details
                </Typography>
                <Box>
                  {role === "Employee" && (
                    <Button
                      className="EnquiryTrackButton"
                      onClick={openConfirmationModal}
                      startIcon={isTracking ? <StopIcon /> : <StartIcon />}
                    >
                      {isTracking ? "Stop Track" : "Start Track"}
                    </Button>
                  )}
                  {(role === "Admin" || role === "Super Admin") && (
                    <Button
                      className="EnquiryMapButton"
                      onClick={showMap}
                    >
                      Map
                    </Button>
                  )}
                </Box>
              </Box>

              <ConfirmationModal
                open={showConfirmation}
                message={
                  isTracking
                    ? "Are you sure you want to stop tracking?"
                    : "Are you sure you want to start tracking?"
                }
                onConfirm={() => {
                  handleToggleTrack();
                  closeConfirmationModal();
                }}
                onCancel={closeConfirmationModal}
              />

              <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
              >
                <DialogTitle id="alert-dialog-title">Confirmation</DialogTitle>
                <DialogContent>
                  <DialogContentText id="alert-dialog-description">
                    Are you sure you want to close this enquiry?
                  </DialogContentText>
                </DialogContent>
                <DialogActions>
                  <Button className="modal_button" onClick={handleClose}>Cancel</Button>
                  <Button className="modal_button" onClick={handleUpdate} autoFocus>
                    Confirm
                  </Button>
                </DialogActions>
              </Dialog>

              <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                  <LabeledTextField
                    label="Company Name"
                    value={companyDetails.name || ""}
                    fullWidth
                    InputProps={{ readOnly: true }}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <LabeledTextField
                    label="Company Type"
                    value={companyDetails.type || ""}
                    fullWidth
                    InputProps={{ readOnly: true }}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <LabeledTextField
                    label="Location"
                    value={companyDetails.location || ""}
                    fullWidth
                    InputProps={{ readOnly: true }}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <LabeledTextField
                    label="Meeting Date"
                    value={
                      formatMeetingDateTime(companyDetails.meeting_date) || ""
                    }
                    fullWidth
                    InputProps={{ readOnly: true }}
                  />
                </Grid>

                <Grid item xs={12}>
                  <Typography variant="body1" className="EnquirySectionLabel">
                    Upload File:
                  </Typography>
                  <Box className="EnquiryFileUploadContainer">
                    <label htmlFor="file-upload-input" className="EnquiryFileLabel">
                      <Box className="EnquiryFileUploadBox">
                        <img
                          src="/upload_file.png"
                          className="EnquiryUploadIcon"
                          alt="Upload"
                        />
                        <input
                          id="file-upload-input"
                          type="file"
                          hidden
                          onChange={handleFileChange}
                        />
                        <Typography className="EnquiryFileText">
                          {file ? `Selected file: ${file.name}` : "No file chosen"}
                        </Typography>
                      </Box>
                    </label>
                    <Button
                      className="EnquiryUploadButton"
                      onClick={handleFileUpload}
                      disabled={!file}
                    >
                      Upload
                    </Button>
                  </Box>
                </Grid>

                <Grid item xs={12}>
                  <LabeledTextField
                    multiline
                    rows={3}
                    fullWidth
                    label="Send Message"
                    placeholder="Enter your message here"
                    value={message}
                    onChange={(e) => setMessage(e.target.value)}
                  />
                  <Button
                    className="EnquirySendMessageButton"
                    onClick={handleSendMessage}
                  >
                    Send Message
                  </Button>
                </Grid>

                <Grid item xs={12}>
                  <Box className="EnquiryWhatsappContainer">
                    <LabeledTextField
                      label="Send WhatsApp Message"
                      fullWidth
                      placeholder="Enter WhatsApp message"
                      value={whatsappMessage}
                      onChange={(e) => setWhatsappMessage(e.target.value)}
                    />
                    <Box className="EnquiryWhatsappFileContainer">
                      <Typography className="EnquirySectionLabel">
                        Send WhatsApp File
                      </Typography>
                      <label
                        htmlFor="whatsapp-file-upload"
                        className="EnquiryFileLabel"
                      >
                        <Box className="EnquiryFileUploadBox">
                          <img
                            src="/upload_file.png"
                            className="EnquiryUploadIcon"
                            alt="Upload"
                          />
                          <input
                            id="whatsapp-file-upload"
                            type="file"
                            hidden
                            onChange={handleWhatsappFileChange}
                          />
                          <Typography className="EnquiryFileText">
                            {whatsappFile
                              ? `Selected file: ${whatsappFile.name}`
                              : "No file chosen"}
                          </Typography>
                        </Box>
                      </label>
                    </Box>
                    <Grid container spacing={2} className="EnquiryButtonGrid">
                      <Grid item>
                        <Button
                          variant="contained"
                          color="success"
                          className="EnquirySendWhatsappButton"
                          onClick={handleSendWhatsappMessage}
                        >
                          Send WhatsApp Message
                        </Button>
                        <Snackbar
                          open={snackbarOpen}
                          autoHideDuration={5000}
                          onClose={() => setSnackbarOpen(false)}
                          anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                          className="EnquirySnackbar"
                        >
                          <Alert
                            onClose={() => setSnackbarOpen(false)}
                            severity={snackbarSeverity}
                            className="EnquiryAlert"
                          >
                            {snackbarMessage}
                          </Alert>
                        </Snackbar>
                      </Grid>
                      <Grid item>
                        <Button
                          variant="contained"
                          color="success"
                          className="EnquiryFeedbackButton"
                          onClick={handleClick}
                        >
                          Feedback URL
                        </Button>
                      </Grid>
                    </Grid>
                  </Box>
                </Grid>
                                <Grid item xs={12}>
  <Button
    variant="contained"
   
    className="EnquiryProductButton"
    onClick={() => setProductModalOpen(true)}
    style={{ backgroundColor: '#fb7102', color: '#fff' }}
  >
    Select Products
  </Button>
</Grid>
              </Grid>
            </CardContent>
          </Card>
        </div>

        <div className="EnquiryColumn EnquiryTimelineColumn">
          <h3 className="EnquiryTimelineTitle">
            <strong>History</strong>
          </h3>
          {/* <VerticalTimeline lineColor="#87CEEB" className="EnquiryCustomTimeline">
            {[...timelineData]
              .sort((a, b) => new Date(b.date) - new Date(a.date))
              .map((item) => (
                <VerticalTimelineElement
                  key={item.id}
                  date={
                    <div className="EnquiryDateCard">
                      {new Date(item.date).toLocaleString()}
                    </div>
                  }
                  dateClassName="EnquiryDateCardWrapper"
                  iconStyle={{
                    background: "#fff",
                    color: "#1976d2",
                    boxShadow: "0 2px 8px rgba(25, 118, 210, 0.18)",
                    border: "2px solid #1976d2",
                    fontSize: "1.5rem",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    padding: 0,
                    lineHeight: 1,
                  }}
                >
                  <h3>{item.employee_name || "Unknown"}</h3>
                  <p>
                    {item.type === "history" ? (
                      <div>
                        <p>Enquiry Created</p>
                        <p className="EnquiryLocationText">
                          Current Location: {addresses[item.id] || "Location not available"}
                        </p>
                      </div>
                    ) : (
                      <p>
                        {item.type === "message"
                          ? item.message
                          : item.type === "file"
                          ? `File: ${item.file_name}`
                          : item.type === "log"
                          ? `Action: ${item.action}`
                          : ""}
                      </p>
                    )}
                  </p>
                  {item.type === "log" &&
                    !(item.previous_update) &&
                    !(item.after_update) && (
                      <div
                        className={
                          item.action === "Tracking Started"
                            ? "EnquiryTrackingStarted"
                            : "EnquiryTrackingStopped"
                        }
                      >
                        <h4 className="EnquiryTrackingTitle">{item.action}</h4>
                        <p className="EnquiryTrackingTimestamp">
                          {new Date(item.timestamp).toLocaleString()}
                        </p>
                        <div className="EnquiryTrackingDetails">
                          <p className="EnquiryTrackingMessage">
                            {item.action === "Tracking Started"
                              ? "Tracking has begun."
                              : "Tracking has been stopped."}
                          </p>
                          <p className="EnquiryLocationText">
                            Location:{" "}
                            <span className="EnquiryLocationHighlight">
                              {addresses[item.id] || "Location not available"}
                            </span>
                          </p>
                        </div>
                      </div>
                    )}
                  {item.previous_update && item.after_update && (
                    <div className="EnquiryUpdateContainer">
                      <div className="EnquiryPreviousUpdate">
                        <h4 className="EnquiryUpdateTitle">Previous</h4>
                        <ul className="EnquiryUpdateList">
                          {Object.entries(item.previous_update).map(
                            ([key, value]) => (
                              <li key={key}>
                                <strong>{key}:</strong> {value}
                              </li>
                            )
                          )}
                        </ul>
                      </div>
                      <div className="EnquiryAfterUpdate">
                        <h4 className="EnquiryUpdateTitle">Updated</h4>
                        <ul className="EnquiryUpdateList">
                          {Object.entries(item.after_update).map(
                            ([key, value]) => (
                              <li key={key}>
                                <strong>{key}:</strong> {value}
                              </li>
                            )
                          )}
                        </ul>
                      </div>
                    </div>
                  )}
                  {item.type === "message" && addresses[item.id] && (
                    <p className="EnquiryLocationText">
                      Location: {addresses[item.id]}
                    </p>
                  )}
                  {item.type === "file" && addresses[item.id] && (
                    <p className="EnquiryLocationText">
                      Location: {addresses[item.id]}
                    </p>
                  )}
                  {item.type === "file" && (
                    <Button
                      startIcon={<FileDownloadIcon />}
                      onClick={() => handleDownload(item.id)}
                      className="EnquiryDownloadButton"
                      size="small"
                      color="primary"
                      variant="contained"
                    >
                      Download
                    </Button>
                  )}
                </VerticalTimelineElement>
              ))}
          </VerticalTimeline> */}
          <VerticalTimeline lineColor="#87CEEB" className="EnquiryCustomTimeline">
  {[...timelineData]
    .sort((a, b) => new Date(b.date) - new Date(a.date))
    .map((item) => (
      <VerticalTimelineElement
        key={item.id}
        date={
          <div className="EnquiryDateCard">
            {new Date(item.date).toLocaleString()}
          </div>
        }
        dateClassName="EnquiryDateCardWrapper"
        iconStyle={{
          background: "#fff",
          color: "#1976d2",
          boxShadow: "0 2px 8px rgba(25, 118, 210, 0.18)",
          border: "2px solid #1976d2",
          fontSize: "1.5rem",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: 0,
          lineHeight: 1,
        }}
      >
        <h3>{item.employee_name || "Unknown"}</h3>
        <p>
          {item.type === "history" ? (
            <div>
              <p>Enquiry Created</p>
              <p className="EnquiryLocationText">
                Current Location: {addresses[item.id] || "Location not available"}
              </p>
            </div>
          ) : (
            <p>
              {item.type === "message"
                ? item.message
                : item.type === "file"
                ? `File: ${item.file_name}`
                : item.type === "log"
                ? `Action: ${item.action}`
                : ""}
            </p>
          )}
        </p>
        {item.type === "log" &&
          !(item.previous_update) &&
          !(item.after_update) && (
            <div
              className={
                item.action === "Tracking Started"
                  ? "EnquiryTrackingStarted"
                  : "EnquiryTrackingStopped"
              }
            >
              <h4 className="EnquiryTrackingTitle">{item.action}</h4>
              <p className="EnquiryTrackingTimestamp">
                {new Date(item.timestamp).toLocaleString()}
              </p>
              <div className="EnquiryTrackingDetails">
                <p className="EnquiryTrackingMessage">
                  {item.action === "Tracking Started"
                    ? "Tracking has begun."
                    : "Tracking has been stopped."}
                </p>
                <p className="EnquiryLocationText">
                  Location:{" "}
                  <span className="EnquiryLocationHighlight">
                    {addresses[item.id] || "Location not available"}
                  </span>
                </p>
              </div>
            </div>
          )}
        {item.previous_update && item.after_update && (
          <div className="EnquiryUpdateContainer">
            <div className="EnquiryPreviousUpdate">
              <h4 className="EnquiryUpdateTitle">Previous</h4>
              <ul className="EnquiryUpdateList">
                {Object.entries(item.previous_update).map(
                  ([key, value]) => (
                    <li key={key}>
                      {/* UPDATED LOGIC BELOW */}
                      <strong>{key}:</strong> {
                        value && typeof value === 'object' 
                          ? (value.product_name || JSON.stringify(value)) 
                          : String(value)
                      }
                    </li>
                  )
                )}
              </ul>
            </div>
            <div className="EnquiryAfterUpdate">
              <h4 className="EnquiryUpdateTitle">Updated</h4>
              <ul className="EnquiryUpdateList">
                {Object.entries(item.after_update).map(
                  ([key, value]) => (
                    <li key={key}>
                      {/* UPDATED LOGIC BELOW */}
                      <strong>{key}:</strong> {
                        value && typeof value === 'object' 
                          ? (value.product_name || JSON.stringify(value)) 
                          : String(value)
                      }
                    </li>
                  )
                )}
              </ul>
            </div>
          </div>
        )}
        {item.type === "message" && addresses[item.id] && (
          <p className="EnquiryLocationText">
            Location: {addresses[item.id]}
          </p>
        )}
        {item.type === "file" && addresses[item.id] && (
          <p className="EnquiryLocationText">
            Location: {addresses[item.id]}
          </p>
        )}
        {item.type === "file" && (
          <Button
            startIcon={<FileDownloadIcon />}
            onClick={() => handleDownload(item.id)}
            className="EnquiryDownloadButton"
            size="small"
            color="primary"
            variant="contained"
          >
            Download
          </Button>
        )}
      </VerticalTimelineElement>
    ))}
</VerticalTimeline>
        </div>
      </div>

      <Modal
        open={modalOpen}
        onClose={closeModal}
        aria-labelledby="modal-title"
        aria-describedby="modal-description"
      >
        <Box className="EnquiryModal">
          <Typography id="modal-description" className="EnquiryModalText">
            {modalMessage}
          </Typography>
          <Button
            color="secondary"
            variant="contained"
            onClick={closeModal}
            className="EnquiryModalButton"
          >
            Close
          </Button>
        </Box>
      </Modal>

      <Modal
        open={feedbackModalOpen}
        onClose={FeedbackcloseModal}
        aria-labelledby="modal-title"
        aria-describedby="modal-description"
      >
        <Box className="EnquiryFeedbackModal">
          <Typography
            id="modal-title"
            variant="h6"
            className="EnquiryModalTitle"
          >
            Feedback URL
          </Typography>
          <Tooltip title="Click to copy" arrow>
            <Typography
              id="modal-description"
              className="EnquiryFeedbackUrl"
            >
              {feedbackModalMessage}
            </Typography>
          </Tooltip>
          <Box className="EnquiryModalButtonContainer">
            <Button
              variant="contained"
              color="primary"
              onClick={handleCopy}
              startIcon={<ContentCopyIcon />}
              className="EnquiryCopyButton"
            >
              Copy URL
            </Button>
            <Button
              color="secondary"
              variant="contained"
              onClick={FeedbackcloseModal}
              className="EnquiryModalButton"
            >
              Close
            </Button>
          </Box>
        </Box>
      </Modal>
<Modal
  open={productModalOpen}
  onClose={() => setProductModalOpen(false)}
  aria-labelledby="product-modal-title"
  aria-describedby="product-modal-description"
>
  {/* This Box is the "paper" or content of the modal */}
  <Box
    sx={{
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      width: { xs: '90%', sm: '70%', md: '50%' },
      maxHeight: '80vh',
      bgcolor: 'background.paper',
      borderRadius: 2,
      boxShadow: 24,
      display: 'flex',
      flexDirection: 'column', // Arrange children vertically
    }}
  >
    {/* --- Modal Header --- */}
    <Box
      sx={{
        display: 'flex',

        justifyContent: 'space-between',
        alignItems: 'center',
        p: 2, // padding
      bgcolor: '#F08B51',
        color: 'white',
      }}
    >
      <Typography id="product-modal-title" variant="h6" component="h2" style={{ color: 'white' }}
>
        Select Products
      </Typography>
      <IconButton
        onClick={handleCloseModal}
        sx={{ color: 'white' }}
        aria-label="close"
      >
        <CloseIcon />
      </IconButton>
    </Box>

    {/* --- Modal Body (Content) --- */}
    <Box
      id="product-modal-description"
      sx={{
        p: 2, // padding
        overflow: 'auto', // Allows this section to scroll if content is too long
        flexGrow: 1, // Allows this section to take up available space
      }}
    >
      <Grid container spacing={2}>
        {products.map((product) => (
          <Grid item xs={12} sm={6} key={product.id}>
            <FormControlLabel
              control={
                <Checkbox
                sx={{
                      bgcolor: '#F08B51',
                      color: 'white',
                      mr: 1,
                      ml: 1

                    }}
                  checked={selectedProducts.includes(product.id)}
                  onChange={(event) => handleProductSelect(event, product.id)}
                />
              }
              label={product.product_name}
            />
          </Grid>
        ))}
      </Grid>
    </Box>

    {/* --- Modal Footer (Actions) --- */}
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'flex-end',
        gap: 1, // adds space between buttons
        p: 2, // padding
        borderTop: '1px solid', // a subtle line to separate from content
        borderColor: 'divider',
      }}
    >
      <Button onClick={() => setProductModalOpen(false)}>Cancel</Button>
      <Button onClick={handleSendProductMail} variant="contained" sx={{
      bgcolor: '#F08B51',
      color: 'white',

    }}>
        Send Mail
      </Button>
    </Box>
  </Box>
</Modal>

<Dialog
  open={mailModalOpen}
  onClose={() => setMailModalOpen(false)}
  aria-labelledby="mail-dialog-title"
  aria-describedby="mail-dialog-description"
>
  <DialogTitle id="mail-dialog-title">Send Mail</DialogTitle>
  <DialogContent>
    <Grid container spacing={2}>
  <Grid item xs={12}>
    <LabeledTextField
      label="Email ID"
      value={emailId}
      onChange={(event) => setEmailId(event.target.value)}
    />
  </Grid>
  <Grid item xs={12}>
    <LabeledTextField
      label="CC"
      value={cc}
      onChange={(event) => setCc(event.target.value)}
    />
  </Grid>
  <Grid item xs={12}>
    <LabeledTextField
      label="Email Body"
      value={emailBody}
      onChange={(event) => setEmailBody(event.target.value)}
      multiline
      rows={4}
    />
  </Grid>
</Grid>
  </DialogContent>
  <DialogActions>
    <Button onClick={() => setMailModalOpen(false)}>Cancel</Button>
    <Button onClick={handleSubmitMail}>Submit</Button>
  </DialogActions>
</Dialog>
    </div>
  );
};

export default EnquiryDashboard;